import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

interface LoadingDialogData {
  title?: string;
  message: string;
  cancelable: boolean;
  onCancel?: () => void;
}

@Component({
  selector: 'stx-loading-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule, MatButtonModule, MatDialogModule],
  host: {
    class: 'flex flex-col items-center justify-center',
  },
  styles: `
    :host {
      .mat-mdc-dialog-title {
        font-size: 1.25rem;
        text-align: center;
      }
    }
  `,
  template: `
    @if (title()) {
      <div matDialogTitle>
        {{ title() }}
      </div>
    }
    <div matDialogContent>
      <div
        class="flex flex-col items-center justify-center gap-4"
        [style.padding-top.px]="title() ? 0 : 40"
      >
        <mat-spinner diameter="60" />

        <div class="text-center">
          <p class="text-on-surface text-lg font-medium">{{ message() }}</p>
        </div>
      </div>
    </div>
    @if (data.cancelable) {
      <div matDialogActions>
        <button
          mat-stroked-button
          type="button"
          class="px-6"
          (click)="onCancel()"
        >
          Cancelar
        </button>
      </div>
    }
  `,
})
export class LoadingDialogComponent {
  data = inject<LoadingDialogData>(MAT_DIALOG_DATA);
  #dialogRef = inject(MatDialogRef<LoadingDialogComponent>);

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);

  updateMessage(newMessage: string): void {
    this.message.set(newMessage);
  }

  onCancel(): void {
    if (this.data.onCancel) {
      this.data.onCancel();
    }
    this.#dialogRef.close();
  }
}
